import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { SopoConfirmData, SopoConfirmSettings } from '../../interfaces/confirm';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';
import { PredictedColor } from '@soposopo/sopo-models';

export interface SopoSideBettingSettings extends SopoConfirmSettings {
    data: SopoSideBettingData;
}

export interface SopoSideBettingData extends SopoConfirmData {
    currency: string;
}

export interface SopoSideBettingResponseData {
    amount: number;
    currency: string;
    color: PredictedColor;
}

@Component({
    selector: 'app-sopo-side-betting',
    templateUrl: './sopo-side-betting.component.html',
    styleUrls: ['./sopo-side-betting.component.scss'],
    standalone: false
})
export class SopoSideBettingComponent implements OnInit, OnDestroy {
    dismissAfterTimeout: NodeJS.Timeout;
    dismissAfter: number = 0;
    step: number = 1;
    closed: boolean = false;
    selectedAmount: number = 5;
    amounts: number[] = [5, 25, 100, 500];
    currency: string = 'golds';
    color: PredictedColor | null = null;
    sCss: string[] = [];

    constructor(
    @Inject(SOPO_DIALOG_DATA) data: SopoSideBettingData,
        private renderer: Renderer2,
        private sopoDialogRef: SopoDialogRef,
        private ref: ChangeDetectorRef,
    ) {
        if (data.currency) this.currency = data.currency;
        if (data.dismissAfter) this.dismissAfter = data.dismissAfter;
        if (data.sCss) this.sCss = data.sCss;
    }

    ngOnInit() { }

    ngAfterViewInit(): void {
        this.getContainerCss();
    }

    getContainerCss() {
        const container = document.getElementsByClassName('now-opening')[0];
        if (this.sCss && this.sCss.length !== 0) {
            for (let className of this.sCss) {
                this.renderer.addClass(container, className);
            };
        }
        this.renderer.removeClass(container, 'now-opening');
    }

    predict() {
        this.step = 2;
    }

    chooseColor(color: 'RED' | 'BLACK') {
        if(this.closed) return
        this.step = 3;
        if(color === 'RED') this.color = PredictedColor.RED
        if(color === 'BLACK') this.color = PredictedColor.BLACK
    }

    selectAmount(amount: number) {
        this.selectedAmount = amount;
    }

    cancel(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        this.closed = true;
        this.ref.detectChanges();
        setTimeout(() => this.sopoDialogRef.close(null), 0);
    }

    confirm() {
        this.closed = true;
        this.ref.detectChanges();
        this.step = 4;
        this.sopoDialogRef.close({
            color: this.color,
            amount: this.selectedAmount,
            currency: this.currency
        });
    }

    ngOnDestroy(): void {
        if (this.dismissAfterTimeout) clearTimeout(this.dismissAfterTimeout);
    }
}
